;globalThis.__fetchLocaleData__ = (function () {
            return async function getLocale(locale) {
                if (locale === "en_US") {
                        return import(/* webpackChunkName: "i18n-en_US" */'/pwa.build/en_US.json');
                    }

                throw new Error('Unable to locate locale ' + locale + ' within generated dist directory.');
            }
        })()